import { CalendarClock } from "lucide-react";
import type { EmailMessage, EmailSettings } from "./api";
import { Eyebrow, Notice, Panel, StatusPill, fmtDate } from "./shared";

export default function SchedulePanel({ messages, settings, onOpen }: { messages: EmailMessage[]; settings: EmailSettings; onOpen: (id: number) => void }) {
  const live = messages.filter((m) => ["approved", "sending", "paused"].includes(m.status))
    .sort((a, b) => (a.scheduled_at || a.approved_at || "").localeCompare(b.scheduled_at || b.approved_at || ""));
  const groups = new Map<string, EmailMessage[]>();
  for (const m of live) {
    const key = m.scheduled_at ? fmtDate(m.scheduled_at, false) : "As soon as pacing allows";
    groups.set(key, [...(groups.get(key) || []), m]);
  }
  return (
    <div className="space-y-5 max-w-3xl">
      {settings.paused && <Notice tone="warn">Marketing sends are paused. Essential account and operational messages still go out.</Notice>}
      <p className="text-sm text-muted-foreground">Marketing pacing: at most {settings.daily_limit} per person per day window, at least {settings.min_hours} hours apart. Approved messages send automatically once due.</p>
      {live.length === 0 ? (
        <Panel className="p-10 text-center"><CalendarClock className="mx-auto w-8 h-8 text-muted-foreground/50" /><p className="mt-2 text-sm text-muted-foreground">Nothing is approved or waiting to send.</p></Panel>
      ) : Array.from(groups.entries()).map(([day, items]) => (
        <div key={day}>
          <Eyebrow>{day}</Eyebrow>
          <ul className="mt-2 border-l-2 border-[#FF5C00]/40 pl-4 space-y-2">
            {items.map((m) => (
              <li key={m.id}>
                <button data-testid={`row-schedule-${m.id}`} onClick={() => onOpen(m.id)} className="w-full text-left rounded-lg border border-border bg-card px-4 py-3 hover:border-[#FF5C00]/40">
                  <div className="flex items-start justify-between gap-2"><p className="font-medium">{m.subject}</p><StatusPill status={m.status} /></div>
                  <p className="mt-1 text-xs text-muted-foreground">{m.scheduled_at ? fmtDate(m.scheduled_at) : "Due now"} · {m.sent}/{m.total} sent · {m.excluded} excluded{m.failed ? ` · ${m.failed} failed` : ""}</p>
                </button>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}
